module.exports = __webpack_public_path__ + "static/media/webcam.b7f4f7a0.svg";